import { Box, Typography } from "@mui/material";
import strings from "global/constants/StringConstants";
import styles from "../ContractSearch.styles";
import PromptChip from "./PromptChip";

interface FollowUpChipsProps {
  questions: string[];
  /** "Suggested follow-ups" after an answer, "Try asking instead" after a refusal or no match. */
  variant: "followUps" | "tryInstead";
  onSelect: (text: string) => void;
  disabled?: boolean;
}

const FollowUpChips = ({
  questions,
  variant,
  onSelect,
  disabled,
}: FollowUpChipsProps) => {
  if (!questions.length) return null;
  const copy = strings.contractSearch;
  const heading =
    variant === "followUps" ? copy.followUpsHeading : copy.tryInsteadHeading;
  return (
    <Box component="section" aria-label={heading.toLowerCase()}>
      <Typography component="h3" sx={styles.followUpsHeading}>
        {heading}
      </Typography>
      <Box sx={styles.followUpsRow}>
        {questions.map((question) => (
          <PromptChip
            key={question}
            text={question}
            onSelect={onSelect}
            disabled={disabled}
            arrow
          />
        ))}
      </Box>
    </Box>
  );
};

export default FollowUpChips;
